const baseURL = process.env.VUE_APP_ROOT_URL;

class CoreAPI {
    constructor() {
        this.userdata = null;
        this.devParam = (process.env.NODE_ENV === 'development') ? '?dev=true' : '';
        this.getLoginStatus();
    }

    is(status){
        switch(status){
            case 'administrator': return this.is('logged_in') && this.userdata.administrator;
            case 'local_user': return this.is('logged_in') && this.userdata.group === 'LOCAL';
            default: return this.status === status;
        }
    }

    getLoginStatus() {
        let self = this;
        this.status = 'pending';
        this.userdata = this._fetch(`logged_in.php`).then(s => {
            self.status = 'logged_in';
            self.userdata = s;
            return s;
        }).catch(() => {
            self.status = 'logged_out';
            self.userdata = Promise.reject("Login failed");
            return null;
        });
        return Promise.resolve(this.userdata);
    }

    login() {
        return `${baseURL}/core/account/login.php${this.devParam}`;
    }

    logout() {
        return `${baseURL}/core/account/logout.php${this.devParam}`;
    }
    
    resetPassword(){
        return `${baseURL}/core/account/passwordreset.php${this.devParam}`;
    }

    createAccount(){
        return `${baseURL}/core/account/register.php${this.devParam}`;
    }

    managementURL(){
        return `${baseURL}/core/`
    }

    activeJobs = () => this._authFetch(`api/active_jobs.php`);
    finishedJobs = () => this._authFetch(`api/finished_jobs.php`);

    upload = blob => this._authFetch(`upload.php`, { body: blob, method: 'POST' });

    shortlog = id => this._textFetch(`download.php?id=${id}&types=shortlog`);
    longlog = id => this._textFetch(`download.php?id=${id}&types=longlog`);
    
    jobSize = id => this._textFetch(`download.php?id=${id}&types=1&size=1`);

    previewURL = id => `${baseURL}/core/job/preview.html?id=${id}`;
    zipURL = (id, types) => `${baseURL}/core/download.php?id=${id}&types=${types.join('~')}`;

    jobAction(act, id) {
        let data = new FormData();
        data.append("id", id);
        return this._authFetch(`job/${act}.php`, { method: 'POST', body: data })
    }

    editJob(id, options, name) {
        let data = new FormData();
        data.append("id", id);
        data.append("name", name);
        data.append("options", JSON.stringify(options));
        return this._authFetch(`job/edit.php`, { body: data, method: 'POST' })
    }

    /**
     * Wrap a fetch request with suitable auth - Need to redo completely.
     * @param {*} stub URL path stub to
     * @param {*} opts Additional fetch options
     */
    _authFetch(stub, opts) {
        switch (this.status) {
            case 'logged_in': return this._fetch(stub, opts);
            case 'logged_out': return Promise.reject("Needs login");
            case 'pending': return this.userdata.then(async () => await this._fetch(stub, opts));
        }
    }

    _fetch = (stub, opts) => this._req(baseURL + '/core/', stub, opts, 'application/json', 'json');
    _textFetch = (stub, opts) => this._req(baseURL + '/core/', stub, opts, 'text/plain', 'text');

    _req(url, stub, opts, mimeAccept, resMethod) {
        return fetch(url + stub, {
            ...opts, headers: { Accept: mimeAccept }, credentials: "include"
        }).then(j => {
            if (j.ok) return j[resMethod]()
            else throw new Error(j.statusText);
        });
    }
}

import Vue from 'vue'
Vue.prototype.$api = new CoreAPI();